export default __webpack_public_path__ + "static/media/performance-criteria-icon.99e4e08d.svg";